import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "label", "isDisabled", "icon", "LabelComponent", "variant"];
/** @jsx jsx */
import React, { useCallback } from 'react';
import { IconWrapper, LabelWrapper, CheckboxWrapper, PillButton } from './filter-item.styled';
import { Checkbox } from '@atlaskit/checkbox';
import { css, jsx } from '@emotion/react';
export var OptionVariant = /*#__PURE__*/function (OptionVariant) {
  OptionVariant["CHECKBOX"] = "CHECKBOX";
  OptionVariant["PILL"] = "PILL";
  return OptionVariant;
}({});
var FilterItem = function FilterItem(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    icon = _ref.icon,
    LabelComponent = _ref.LabelComponent,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var onChangeCallback = useCallback(function (e) {
    if (variant === OptionVariant.PILL) {
      onChange === null || onChange === void 0 || onChange(value, !rest.isChecked);
    } else {
      onChange === null || onChange === void 0 || onChange(e.target.value, e.target.checked);
    }
  }, [variant, onChange, value, rest.isChecked]);
  switch (variant) {
    case OptionVariant.PILL:
      return jsx(PillButton, {
        selected: rest.isChecked,
        "aria-pressed": rest.isChecked,
        onClick: onChangeCallback
      }, label);
    case OptionVariant.CHECKBOX:
    default:
      return jsx(CheckboxWrapper, null, jsx(Checkbox, _extends({}, rest, {
        value: value,
        onChange: onChangeCallback
        // Target the svg to move to the left and down
        ,
        css: css({
          '& + svg': {
            margin: "var(--ds-space-025, 2px)".concat(" 0 0 ", "var(--ds-space-negative-050, -4px)")
          }
        }),
        isDisabled: isDisabled,
        label: jsx(LabelWrapper, null, icon && jsx(IconWrapper, null, icon), jsx(LabelComponent, null, label))
      })));
  }
};
export default /*#__PURE__*/React.memo(FilterItem);